<template>
  <div id="metricwire">
    <h2 v-if="categories.length == 0" class="is-size-4">
      {{ survey.surveyName }}
    </h2>

    <div v-else class="dropdown" v-bind:class="{ 'is-active': toggleCategoriesDropdown }">
      <div class="dropdown-trigger">
        <button class="button"
          aria-haspopup="true"
          aria-controls="dropdown-menu"
          v-on:click="toggleCategoriesDropdown = !toggleCategoriesDropdown">
          <span>{{ selectedCategory }}</span>
          <span class="icon is-small">
            <i v-if="toggleCategoriesDropdown" class="fas fa-angle-up" aria-hidden="true"></i>
              <i v-else class="fas fa-angle-down" aria-hidden="true"></i>
          </span>
        </button>
      </div>
      <div class="dropdown-menu" id="dropdown-menu" role="menu">
        <div class="dropdown-content">
          <a v-for="(cat, index) in categories" :key="index"
            class="dropdown-item"
            v-on:click="onSurveyCategorySelect(cat)">
            {{cat.name}}
          </a>
        </div>
      </div>
    </div>
    <br v-if="categories.length !== 0" />
    <div class="dropdown vragen" v-bind:class="{ 'is-active': toggleDropdown }">
      <div class="dropdown-trigger">
        <button class="button"
          aria-haspopup="true"
          aria-controls="dropdown-menu"
          v-on:click="toggleDropdown = !toggleDropdown">
          <span>{{ selectedQuestion }}</span>
          <span class="icon is-small">
            <i v-if="toggleDropdown" class="fas fa-angle-up" aria-hidden="true"></i>
              <i v-else class="fas fa-angle-down" aria-hidden="true"></i>
          </span>
        </button>
      </div>
      <div class="dropdown-menu" id="dropdown-menu" role="menu">
        <div class="dropdown-content">
          <a v-for="(sm, index) in Object.keys(survey.surveyMeta)" :key="index"
            class="dropdown-item"
            v-if="survey.surveyMeta[sm].type === 'SINGLE_CHOICE'"
            v-on:click="onSurveyQuestionSelect(survey.surveyMeta[sm])">
            {{ survey.surveyMeta[sm].question }}
          </a>
        </div>
      </div>
    </div>
    <HorizontalBarChart
      class="weather"
      :chartData="hBarChartData"
      :options="hBarChartOptions"
      :height="200"
      />
    <p>Aantal antwoorden: {{ numAnswers }}</p>
    <p>Aantal vragen overgeslagen: {{ numSkipped }}</p>
    <p>Aantal vragen onbeantwoord: {{ numNoAnswer }}</p>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import HorizontalBarChart from '../Surveys/HorizontalBarChart'

export default {
  name: 'MetricWire',
  components: {
    HorizontalBarChart
  },
  props: {
    selectedItem: Object,
  },
  mounted() {
    this.$store.dispatch('setSelectedSurvey', this.selectedItem.properties.Name)
  },
  watch: {
    selectedItem(item) {
      this.$store.dispatch('setSelectedSurvey', item.properties.Name)
      this.resetHBar()
      this.selectedCategory = 'Kies een straat'
    }
  },
  computed: {
    ...mapGetters({
      survey: 'dataMetricWireSelectedSurvey',
      categories: 'dataMetricWireSelectedCategories'
    })
  },
  methods: {
    onSurveyQuestionSelect(selected) {
      this.toggleDropdown = !this.toggleDropdown
      this.numAnswers = this.survey.submissions.length
      let response = {}
      for (var i = 0; i < this.survey.submissions.length; i++) {
        let answer = this.survey.submissions[i].questionValues[selected.id]
        if (isNaN(response[answer.response])) {
          response[answer.response] = 1
        } else {
          response[answer.response] = response[answer.response] + 1
        }
      }
      let chartData = { ...this.hBarChartData }
      chartData.labels = selected.choices
      chartData.datasets[0].label = selected.question
      for (var i = 0; i < selected.choices.length; i++) {
        chartData.datasets[0].data.push(response[selected.choices[i]])
      }
      this.hBarChartData = chartData
      this.numSkipped = response.SKIPPED || 0
      this.numNoAnswer = response.NO_ANSWER || 0
    },
    onSurveyCategorySelect(selectedCategory) {
      this.toggleCategoriesDropdown = !this.toggleCategoriesDropdown
      this.selectedCategory = selectedCategory.name
      let dataset = require(`../../assets/metricwire/deventer/submissions/${selectedCategory.id}.json`)
      this.$store.commit('setDataMetricWireSelectedSurvey', dataset)

      this.resetHBar()
    },
    resetHBar() {
      this.hBarChartData = { labels: [], datasets: [{ label: '', backgroundColor: 'rgba(34, 208, 178, 0.8)', data: []}]}
    }
  },
  data() {
    return {
      toggleDropdown: false,
      toggleCategoriesDropdown: false,
      selectedCategory: 'Kies een straat',
      selectedQuestion: 'Kies een vraag',
      numSkipped: 0,
      numNoAnswer: 0,
      numAnswers: 0,
      hBarChartData: {
        labels: [],
        datasets: [{
          label: '',
          backgroundColor: 'rgba(34, 208, 178, 0.8)',
          data: []
        }]
      },
      hBarChartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: true,
          position: 'top',
          labels: {
            boxWidth: 0,
            fontColor: 'black'
          }
        },
      },
    }
  }
}
</script>

<style scoped>
.dropdown-item {
  text-overflow: ellipsis;
}
.dropdown-menu {
  width: 380px;
}
.vragen {
  padding-top: 10px;
}
</style>
